var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80039 4.80001C4.80039 3.81177 5.60155 3.01062 6.58979 3.01062H9.41059C10.3988 3.01062 11.2 3.81177 11.2 4.80001V5.20001H12.0004C12.5308 5.20001 12.9604 5.62962 12.9604 6.16001V12.8C12.9604 13.3304 12.5308 13.76 12.0004 13.76H4.00039C3.47001 13.76 3.04039 13.3304 3.04039 12.8V6.16001C3.04039 5.62962 3.47001 5.20001 4.00039 5.20001H4.80039V4.80001ZM5.60039 5.20001H10.4V4.80001C10.4 4.25373 9.95687 3.81062 9.41059 3.81062H6.58979C6.04351 3.81062 5.60039 4.25373 5.60039 4.80001V5.20001ZM4.00039 6.00001V12.8C4.00039 12.9061 4.04253 13.0078 4.11755 13.0829C4.19256 13.1579 4.2943 13.2 4.40039 13.2H11.6004C11.7065 13.2 11.8082 13.1579 11.8832 13.0829C11.9582 13.0078 12.0004 12.9061 12.0004 12.8V6.00001H4.00039ZM6.40039 8.00001C6.40039 7.55818 6.75856 7.20001 7.20039 7.20001C7.64222 7.20001 8.00039 7.55818 8.00039 8.00001C8.00039 8.44184 7.64222 8.80001 7.20039 8.80001C6.75856 8.80001 6.40039 8.44184 6.40039 8.00001Z",
    fill: "#FFFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.c28814c61b4e5b34fefe1db6813643c5.svg";
export { ForwardRef as ReactComponent };